<div class="error-wrapper">
    <div class="wrapper">
  
      <div class="content">
        <div class="main">
  
          <div class="form-wrapper-content">
            <div class="form-wrapper-body">
                <!-- <div class="form-warpper-body"> -->
                    <div class="form-warpper-body-new-txt">
                        <h3 class="blue-new-color">
                          Temporary Downtime for COINDEPO Token Listing
                        </h3>
                        <p>
                          To bring you the COINDEPO token launch, we’re doing some quick upgrades.
                        </p>
                        <p>
                          The service will be back online shortly - thanks for your patience!
                        </p>
                        <a href="" class="btn btn-link"> &#8592;
                          Back to CoinDepo 
                        </a>
                      </div>
                      <div>
                        <img
                            class="img-form-warpper-body"
                            src="https://static.coindepo.com/images/token-top.svg"
                            alt="CoinDepo"
                        >
                      </div>
                <!-- </div> -->
            </div>
  
          </div>
  
  
        </div>
  
      </div>
  
  
    </div>
  
  
  </div>
  